/**
 * S3 첨부파일 API 모듈.
 *
 * axios 공통 인스턴스(src/api/index.js)를 사용하며,
 * 인증 토큰과 Authorization 헤더는 index.js에서 공통 처리한다.
 *
 * path 예시: product/PROD001/, trade-policy/TP_GOLD_BOTH_DEFAULT/
 */
import api from './index'

/* ================================================================
 * 첨부파일 API
 * ================================================================ */

/**
 * 파일 업로드.
 *
 * @param {string} path - S3 저장 경로 prefix (예: product/PROD001/)
 * @param {File} file - 업로드할 파일
 * @returns {Promise} { data: { code, objectKey, path, url }, ... }
 */
export function uploadAttachment(path, file) {
  const formData = new FormData()
  formData.append('path', path)
  formData.append('file', file)
  // FormData 전송 시 Content-Type은 브라우저가 boundary와 함께 자동으로 설정한다.
  return api.post('/api/v1/attachment/upload', formData, {
    timeout: 60000,
    transformRequest: [(data, headers) => {
      if (data instanceof FormData && headers && headers['Content-Type']) {
        delete headers['Content-Type']
      }
      return data
    }],
  })
}

/**
 * Presigned URL 조회.
 *
 * @param {string} objectKey - S3 object key 전체 경로 (예: product/PROD001/abc123-image.png)
 * @returns {Promise} { data: { code, presignedUrl, expiresAt }, ... }
 */
export function getPresignedUrl(objectKey) {
  return api.post('/api/v1/attachment/presigned-url', { path: objectKey })
}

/**
 * 파일 삭제.
 *
 * @param {string} objectKey - S3 object key 전체 경로
 * @returns {Promise} { data: { code, message }, ... }
 */
export function deleteAttachment(objectKey) {
  return api.delete('/api/v1/attachment', { params: { path: objectKey } })
}
